import { Component, OnInit } from '@angular/core';
import { UserProfileService } from './_services/user-profile.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { UserProfile } from './_models/user-profile';
import { NavLinkAvailabilityService } from './_services/nav-link-availability.service';
import { PortalApps } from './_models/portal-routes';
import { ConfigurationService } from './_services/configuration.service';
import { AuthenticationService } from './_services/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'ClientApp';
  userProfile: UserProfile;
  availableLinks: PortalApps[];
  showDashboards: boolean = true;

  constructor(
    private userService: UserProfileService,
    private permissionService: NgxPermissionsService,
    private navLinkService: NavLinkAvailabilityService,
    private configurationService: ConfigurationService,
    private authenticationService: AuthenticationService
  ) {
    this.showDashboards = this.configurationService.config.showDashboards;
    this.configurationService.configData$.subscribe(res => {
      this.showDashboards = res.showDashboards;
    })

    this.userService.userProfile$.subscribe(result => {
      this.userProfile = result;
    });

    this.navLinkService.availableLinks$.subscribe(result => {
      this.availableLinks = result;
    })
  }

  ngOnInit(): void {
    if (this.authenticationService.webAppVersionOneStorageFound()) {
      this.authenticationService.logout(true);
    }
    else {
      if (this.userProfile && this.userProfile.permissions && this.userProfile.permissions.length) {
        if (this.userProfile.permissions.length > 0) {
          this.availableLinks.forEach(app => {
            if (app.application == 'controlPanel') {
              app.enabled = true;
              app.routes.forEach(route => {
                if (route.name == 'users') {
                  route.enabled = true;
                }
                if (route.name == 'wells') {
                  route.enabled = true;
                }
              })
            }
            if (app.application == 'portal') {
              app.routes.forEach(route => {
                if (route.name == 'dashboards') {
                  route.enabled = this.showDashboards;
                }
              })
            }
          })
        }
        else {
          this.availableLinks.forEach(app => {
            if (app.application == 'controlPanel') {
              app.enabled = false;
            }
            if (app.application == 'portal') {
              app.routes.forEach(route => {
                if (route.name == 'dashboards') {
                  route.enabled = this.showDashboards;
                }
              })
            }
          })
        }

        this.permissionService.loadPermissions(this.userProfile.permissions);
      }
      else {
        this.availableLinks.forEach(app => {
          if (app.application == 'controlPanel') {
            app.enabled = false;
          }
          if (app.application == 'portal') {
            app.routes.forEach(route => {
              if (route.name == 'dashboards') {
                route.enabled = this.showDashboards;
              }
            })
          }
        })
      }

      this.navLinkService.updateAvailableLinks(this.availableLinks);
    }
  }
}
